import styled from "styled-components";

export const StyledSimilarJobsImagesPage = styled.div``;